module.exports = __webpack_public_path__ + "static/media/emergency.76fce215.svg";